<div class="{{className}} checkbox-container" [ngClass]="options != undefined ? 'check-group' : ''">
  @if (options == undefined  && !is_rich_text) {
    <label class="check-wrapper" (keyup.enter)="onEnter($event)">
      @if (showLabel) {
        <p class="truncate-text" [ngClass]="!required ? '': 'required'">{{label?(label | translate | async):''}}
        </p>
        <!-- <sup *ngIf="required" class="req">*</sup> -->
      }
      <input type="checkbox" [disabled]="disabled_" (change)="onSelect($event)" class="checkbox" [value]="value"
        [id]="id" [checked]="getValue(value)" tabindex="-1">
      <span class="check-mark" [tabindex]="!disabled_ ? 0 : -1"></span>
    </label>
  }

  @if (options == undefined && is_rich_text) {
    <label class="check-wrapper" (keyup.enter)="onEnter($event)">
      @if (showLabel) {
        <div [innerHTML]="label | safeStyleHtml">
          <p class="truncate-text" [ngClass]="!required ? '': 'required'">{{label?(label | translate | async):''}}
          </p>
          <!-- <sup *ngIf="required" class="req">*</sup> -->
        </div>
      }
      <input type="checkbox" [disabled]="disabled_" (change)="onSelect($event)" class="checkbox" [value]="value"
        [id]="id" [checked]="getValue(value)" tabindex="-1">
      <span class="check-mark" tabindex="0"></span>
    </label>
  }

  @if (options != undefined) {
    <!-- Check if MultiCkbLayout exists and has a valid value -->
    @if (mckbClass) {
      @for (option of options; track option) {
        <div
          [ngClass]="mckbClass">
          <label (keyup.enter)="onEnter($event)" class="check-wrapper">
            <p class="truncate-text">{{option[question.getterValue || 'value'] | translate | async}}</p>
            @if (!checkTypeValue(value)) {
              <input type="checkbox" (change)="onSelect(option[question.getterKey || 'id'])" class="checkbox"
                [value]="option[question.getterKey || 'id']" [checked]="value ? (value===(option[question.getterKey || 'id'])) : false" [id]="option[question.getterKey || 'id']" tabindex="-1">
            }
            @if (checkTypeValue(value)) {
              <input type="checkbox" (change)="onSelect(option[question.getterKey || 'id'])" class="checkbox"
                [value]="option[question.getterKey || 'id']" [checked]="value ? is_present(value,option[question.getterKey || 'id']) : false" [id]="option[question.getterKey || 'id']"
                tabindex="-1">
            }
            <span class="check-mark" tabindex="0"></span>
          </label>
        </div>
      }
    }
    <!-- Check if MultiCkbLayout does not exist, is null or empty -->
    @if (!mckbClass) {
      @for (option of options; track option) {
        <label (keyup.enter)="onEnter($event)" class="check-wrapper">
          <p class="truncate-text">{{option[question.getterValue || 'value'] | translate | async}}</p>
          @if (!checkTypeValue(value)) {
            <input type="checkbox" (change)="onSelect(option[question.getterKey || 'id'])" class="checkbox"
              [value]="option[question.getterKey || 'id']" [checked]="value ? (value===(option[question.getterKey || 'id'])) : false" [id]="option[question.getterKey || 'id']" tabindex="-1">
          }
          @if (checkTypeValue(value)) {
            <input type="checkbox" (change)="onSelect(option[question.getterKey || 'id'])" class="checkbox"
              [value]="option[question.getterKey || 'id']" [checked]="value ? is_present(value,option[question.getterKey || 'id']) : false" [id]="option[question.getterKey || 'id']"
              tabindex="-1">
          }
          <span class="check-mark" tabindex="0"></span>
        </label>
      }
    }
  }
</div>